import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import Spinner from './Spinner';
import './ui.css';

type ButtonVariant = 'primary' | 'ghost';

interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'ref'> {
  variant?: ButtonVariant;
  loading?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', loading = false, disabled, children, className = '', ...rest }, ref) => (
    <motion.button
      ref={ref}
      className={`ui-btn ui-btn--${variant} ${className}`}
      whileTap={{ scale: 0.97 }}
      transition={{ duration: 0.12 }}
      disabled={disabled || loading}
      {...rest}
    >
      <span className="ui-btn__content">
        <>
          {loading && <Spinner />}
          {children}
        </>
      </span>
    </motion.button>
  )
);

Button.displayName = 'Button';

export default Button;
